<style lang="scss">
  .homeContent {
    overflow: hidden;
    .homeCats {
      .container {
        > ul {
          > li {
            margin-bottom: 140px;
            .books {
              display: grid;
              grid-template-columns: repeat(5, 1fr);
              grid-gap: 40px;
            }
          }
        }
      }
    }
    footer {
      margin-top: 0;
    }
  }
</style>
<template>
  <div class="homeContent">
    <FrontendNav></FrontendNav>
    <FrontendHomeTop></FrontendHomeTop>
    <FrontendHomeFeatured :books="featured"></FrontendHomeFeatured>
    <FrontendHomeCategories :catList="categories"></FrontendHomeCategories>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'
import FrontendHomeTop from './top'
import FrontendHomeFeatured from './featured'
import FrontendHomeCategories from './categories'

export default {
  name: 'FrontendHome',
  components: {
    FrontendNav,
    FrontendFooter,
    FrontendHomeTop,
    FrontendHomeFeatured,
    FrontendHomeCategories
  },
  data: function () {
    return {
      categories: {},
      featured: []
    }
  },
  created: function () {
    let url = process.env.API_URL + '/' + process.env.API_ENDPOINT
    this.$http
      .get(url + `/book/index`, {
        'headers': {
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.categories = res.data.categories
        this.featured = res.data.featured
      }).catch(res => {
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/home/home.vue